import React, { type JSX } from 'react';

import styles from './ConfirmationModal.module.css';

export default function Actions({
  children,
}: {
  children?: React.ReactNode;
}): JSX.Element {
  return <div className={styles.Actions}>{children}</div>;
}
